import { render } from "./screenshot.vue?vue&type=template&id=53077446"
import script from "./screenshot.vue?vue&type=script&lang=js"
export * from "./screenshot.vue?vue&type=script&lang=js"

import "./screenshot.vue?vue&type=style&index=0&id=53077446&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__